import script from "./icon-charts.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-charts.vue?vue&type=script&lang=ts&setup=true"

import "./icon-charts.vue?vue&type=style&index=0&id=043f961d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043f961d"]])

export default __exports__